export default "__VITE_ASSET__BGTEox_v__"